<template>
  <div class="box">
    <div class="searchBox">
      <div class="back" v-on:click="back">
        <img src="../assets/GoBack.png" alt />
      </div>
      <div class="search">
        <img src="../assets/search.png" alt />
        <input type="text" id="searchBox" placeholder="输入店铺名称" />
      </div>
      <div class="clickSearch" v-on:click="searcAttention">搜索</div>
    </div>
    <div class="infinite-list-wrapper shopAttentionList" style="overflow:auto;margin-top:1.3rem">
      <ul class="list" v-infinite-scroll="load" infinite-scroll-disabled="disabled">
        <li class="list-item" v-for="(item,index) in MyFollowList" :key="index">
          <div class="shopList">
            <div class="Already">
              <img src="../assets/already.png" alt />
              已关注
            </div>
            <div class="shopName" v-on:click="toShopIndex(item)">
              <div class="shopImg">
                <img :src="CShttp+item.shop_icon_image" alt />
              </div>
              <div class="Name">
                <div class="NameText">{{item.name}}</div>
                <div class="shopInfo">
                  <div>
                    <span>餐饮美食</span>
                    <span class="shopInfoCenter">|</span>
                    <span>月销量{{item.xiaoliang?item.xiaoliang:0}}</span>
                  </div>
                  <div>{{(item.juli/1000).toFixed(2)}}km</div>
                </div>
              </div>
            </div>
            <div class="couponList" style="display:none">
              <div v-for="(coupon,idxs) in item.coupon_list" :key="idxs">
                <MycouponList
                  class="animated bounceIn"
                  :IconImg="item.shop_icon_image"
                  :CouponInfo="coupon"
                  type="MyAttention"
                  MycouponIndex="0"
                ></MycouponList>
              </div>
              <!-- <MycouponList
                class
                :IconImg="item.shop_icon_image"
                :CouponInfo="coupon"
                type=""
                MycouponIndex="0"
              ></MycouponList>-->
            </div>
            <div class="packUp" data-id="0" style="display:none" v-on:click="packUp">
              点击收起优惠卷
              <img src="../assets/top.png" alt />
            </div>
            <div class="sentOut" data-id="1" v-on:click="packUp">
              点击展示优惠卷
              <img src="../assets/bottom.png" alt />
            </div>
          </div>
        </li>
      </ul>
      <p v-if="loading">加载中...</p>
      <p v-if="noMore">没有更多了</p>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import MycouponList from "../components/MycouponList";
export default {
  name: "",
  data() {
    return {
      CShttp: this.$store.state.CShttp,
      page: 1,
      MyFollowList: [],
      pageSize: 10,
      loading: false
    };
  },
  components: {
    MycouponList
  },
  computed: {
    noMore() {
      return this.count >= 20;
    },
    disabled() {
      return this.loading;
    }
  },
  created() {},
  mounted() {
    var openid = localStorage.getItem("ZQopenid");
    var UserInfo = localStorage.getItem("ZQUserInfo")
      ? JSON.parse(localStorage.getItem("ZQUserInfo"))
      : "";
    var location = JSON.parse(localStorage.getItem("ZQlocation"));
    this.$store.commit("location", location);
    this.$store.commit("UserInfo", {
      UserInfo: UserInfo
    });
    this.$store.commit(
      "UserSelf",
      JSON.parse(localStorage.getItem("ZQUserSelf"))
    );
    this.UserInfo = UserInfo;
    this.openid = UserInfo.openid;
    this.MyFollow();
  },
  methods: {
    searcAttention() {
      this.$http
        .get("/api/shop/search_follow_shop", {
          params: {
            uid: this.$store.state.useId,
            name: $("#searchBox").val(),
            log: this.$store.state.log,
            lat: this.$store.state.lat
          }
        })
        .then(res => {
          console.log(res.data);
          if (res.data.code == 1) {
            this.MyFollowList = [];
            res.data.data.action.map(item => {
              this.MyFollowList.push(item);
            });
          }
        });
    },
    load() {
      console.log("上拉加载");
    },
    back() {
      this.$router.go(-1);
    },
    packUp(e) {
      console.log(e);
      var id = e.target.dataset.id;
      $(e.target)
        .parents(".shopList")
        .children(id == 0 ? ".packUp" : ".sentOut")
        .css({
          display: "none"
        })
        .parents(".shopList")
        .children(".couponList")
        .css({
          display: id == 0 ? "none" : "block"
        });
      $(e.target)
        .parents(".shopList")
        .children(id == 0 ? ".sentOut" : ".packUp")
        .css({
          display: "flex"
        });
    },
    MyFollow() {
      this.$http
        .get("/api/shop/search_follow_shop", {
          params: {
            uid: this.$store.state.useId,
            name: "",
            log: this.$store.state.log,
            lat: this.$store.state.lat
          }
        })
        .then(res => {
          console.log(res.data);
          if (res.data.code == 1) {
            res.data.data.action.map(item => {
              for (var i = 0; i < item.coupon_list.length; i++) {
                item.coupon_list[i].shop_info = { name: item.name };
              }
              this.MyFollowList.push(item);
            });
          }
        });
    },
    //跳转商品详情页
    toShopIndex(item) {
      this.$router.push({ path: "/shopIndex", query: { id: item.id } });
    }
  }
};
</script>
<style lang='scss' scoped>
.box {
  overflow: hidden;
}
.back {
  position: absolute;
  top: 0.4rem;
  left: 0.2rem;
  width: 0.4rem;
  height: 0.4rem;
  z-index: 1000;
}
.back img {
  width: 100%;
  height: 100%;
  display: inline-block;
}
.shopAttentionList {
  margin-top: 1.3rem;
  background: white;
  height: 100vh;
  position: relative;
  height: 90vh;
}
.searchBox {
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  padding-left: 0.9rem;
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
  font-size: 0.24rem;
  width: 100%;
  z-index: 1000;
}
.search {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-radius: 0.4rem;
  border: 1px solid #e5e5e5;
  width: 5rem;
  height: 0.8rem;
  padding-left: 0.3rem;
}
.searchBox img {
  width: 0.5rem;
  height: 0.5rem;
  display: inline-block;
  margin-right: 0.2rem;
}
.searchBox input {
  border: none;
  outline: none;
  -webkit-appearance: none;
}
.clickSearch {
  width: 1.4rem;
  height: 100%;
  color: #cd160d;
  font-size: 0.32rem;
  text-align: center;
  line-height: 0.8rem;
  flex-shrink: 0;
}

.shopList {
  position: relative;
  margin: 0.3rem 0.25rem 0 0.25rem;
  padding: 0.35rem 0.15rem 0.35rem 0.15rem;
  padding-bottom: 0;
  background: #f5f5f5;
  border-radius: 0.2rem;
}
//商店表头
.shopName {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  padding: 0 0.3rem;
}
.shopName > .shopImg {
  width: 0.9rem;
  height: 0.9rem;
  border-radius: 100%;
  overflow: hidden;
  flex-shrink: 0;
  z-index: 100;
}
.shopImg > img {
  width: 0.9rem;
  height: 0.9rem;
  flex-shrink: 0;
}
.Name {
  width: 100%;
  margin-left: 0.3rem;
  position: relative;
}
.NameText {
  margin-top: 0.1rem;
  font-size: 0.26rem;
  line-height: 0.4rem;
}
.shopInfo {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.24rem;
  color: #636363;
}
.shopInfoCenter {
  display: inline-block;
  margin: 0 0.2rem;
}
.packUp,
.sentOut {
  width: 100%;
  color: #cd160d;
  font-size: 0.26rem;
  text-align: center;
  line-height: 0.9rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.packUp img,
.sentOut img {
  width: 0.4rem;
  height: 0.4rem;
}

.Already {
  height: 0.75rem;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 100;
  background: red;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.24rem;
  color: white;
  border-top-right-radius: 0.2rem;
  border-bottom-left-radius: 0.2rem;
  width: 1.8rem;
}
.Already img {
  width: 0.4rem;
  height: 0.4rem;
}
</style>
